
/**
 * App initial values for the redux state.
 */
export const INITIAL_STATE = {
  stateVersion: null,
  authenticated:false,
  lang:'en',
}
